// Module
var code = `<customer-breadcrumbs></customer-breadcrumbs>
<customer-profile-header></customer-profile-header>
<section class="box">
  <div class="info info--deposit">
    <div class="info-detail">
      <span class="key">Account number:</span>
      <span class="value">{{\$ctrl.account.productNumber}}
        </span>
    </div>
  </div>

  <h2 class="section-header">Update account signature card</h2>

  <form name="\$ctrl.form">
    <file-upload
      ng-model="\$ctrl.signatureCardFiles"
      validate-uploaded
      name="documentUpload"
      enable-webcam="false"
      show-remarks="true"
      show-file-name="true"
      max-files="1"
      allow-duplicates="false"
    ></file-upload>

    <div class="buttons">
      <button
        class="btn btn-warning"
        ng-click="\$ctrl.redirectBack()">
        Cancel
      </button>
      <button
        class="btn btn-primary"
        ng-click="\$ctrl.update()"
        ng-disabled="\$ctrl.form.\$invalid">
        Update
      </button>
    </div>
  </form>

</section>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/accounts/edit-account-signature-card/edit-account-signature-card.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;